<span class='alert validationmessage' *ngIf='ngForm.submitted && ngForm.invalid'>
    <span translate=resources.validationmessagedirective-validationmessage-error></span>
</span>